import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { DevicesService } from "../../entities/devices/devices.service";
import { Device } from "../../entities/devices/devices.model_new";
import { GeneralService } from "../services/general.service";
import { SessionStateService } from "../../core/services/session-state.service";
import { SharedUtils } from "../shared.utils";
import { DatePipe, DecimalPipe } from "@angular/common";
import { map } from "rxjs/operator/map";
import { EnergyService } from "../../entities/energy/energy.service";
import { Observable, Subscribable } from "rxjs/Observable";
import { HousesService } from "../../entities/houses/houses.service";
import { Subscription } from "rxjs/Subscription";
import {
  HOUSE_TARIFF,
  HOUSE_BILLING_PERIOD,
  HOUSE_COUNTRIES,
} from "../../entities/houses/houses.constants";
import { saveAs } from "file-saver";
import * as ExcelJS from "exceljs/dist/exceljs.min.js";
import * as moment from "moment";

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

@Component({
  selector: "app-new-graph",
  templateUrl: "./new-graph.component.html",
  styleUrls: ["./new-graph.component.scss"],
})
export class NewGraphComponent implements OnInit {
  @ViewChild("canvas") canvas: ElementRef;
  @Input() device: Device;
  @Input() consumptionAndGeneration?: boolean;
  @Input() isGeneration?: boolean;
  @Input() hideUnitsToggle?: boolean;
  @Input()
  energySection?: boolean;
  @Input()
  isPrediction?: boolean;
  @Input()
  isPower?: boolean;

  @Output()
  maxPowerMeasured: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  modeOutput: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  dateChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  totalsOutput: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  auxTotalsOutput: EventEmitter<any> = new EventEmitter<any>();

  isSpainCountry = false;
  SharedUtils = SharedUtils;
  /**Chart Variables */
  values;
  public ChartType = "bar";
  public ChartData: any[] = [];
  public ChartLabels: string[];
  public ChartColors: Array<any>;
  public ChartLegend = false;
  public selectedMoments;
  startBillingDate: string;
  endBillingDate: string;
  activeView = "H";
  previousView: string;
  previousViewCustom: string;
  selectedDate: string;
  isConsumptionGraph: boolean;
  gradient: any;
  mode = "Eur";
  totals: any;
  totalsAux: Array<any> = new Array();

  noData = false;
  currentSelectedDate = new Date(Date.now());
  maxValue = 0;
  totalValue = 0;
  nextArrowPossible = false;

  allSchedules = true;
  normalSchedules = true;
  economicSchedules = true;
  superEconomicSchedules = true;
  supliedtoGridSchedules = true;
  selfConsumptionSchedules = true;
  numberOfTariffs = 1;
  /** Prediction */
  currentYear = String(new Date(Date.now()).getFullYear());
  /**Loadings**/
  loading = false;
  contractedPower: any;
  contractedPowerUnit: any;
  selfSubscription: Subscription;
  injectionSubscription: Subscription;

  constructor(
    private sessionStateService: SessionStateService,
    private devicesService: DevicesService,
    private generalService: GeneralService,
    private energyService: EnergyService,
    private houseService: HousesService,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe
  ) {
    moment.locale(this.sessionStateService.getLang());
  }

  /**Chart Options */
  public ChartOptions: any = {
    scaleShowVerticalLines: false,
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          stacked: true,
          gridLines: {
            color: "#ECECEC",
            display: false,
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
          gridLines: {
            color: "#ECECEC",
            display: true,
          },
          ticks: {
            min: 0,
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          const xLabel = data.datasets[tooltipItem.datasetIndex].label || "";
          const yLabel = this.convertToLocaleFormat(tooltipItem.yLabel);
          return `${xLabel}: ${yLabel}`;
        },
      },
    },
  };
  /**Power Options*/
  public powerChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    scaleShowVerticalLines: false,
    elements: {
      line: { tension: 0, borderWidth: 2, borderColor: "#ea524b" },
      point: { radius: 0 },
    },
    scales: {
      xAxes: [
        {
          stacked: true,
          gridLines: {
            color: "#ECECEC",
            display: false,
          },
        },
      ],
      yAxes: [
        {
          stacked: false,
          gridLines: {
            color: "#ECECEC",
            display: true,
          },
          ticks: { min: 0 },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          const xLabel = data.datasets[tooltipItem.datasetIndex].label || "";
          const yLabel = this.convertToLocaleFormat(tooltipItem.yLabel);
          return `${xLabel}: ${yLabel}`;
        },
      },
    },
  };
  public powerChartColors: Array<any>;

  ngOnInit() {
    if (this.sessionStateService.getHouse().country === HOUSE_COUNTRIES.SPAIN) {
      this.isSpainCountry = true;
    }

    if (this.isPower) {
      this.setGradient();
    } else {
      this.isConsumptionGraph = this.device
        .getHistoricVars()
        ["supported"].includes("ActiveEnergyConsumed");
      this.modeOutput.emit(this.mode);
    }

    if (this.sessionStateService.getHouseTariff().tariff === HOUSE_TARIFF.BI) {
      this.numberOfTariffs = 2;
    } else if (
      this.sessionStateService.getHouseTariff().tariff === HOUSE_TARIFF.TRI
    ) {
      this.numberOfTariffs = 3;
    }

    if (this.hideUnitsToggle) {
      this.mode = "kWh";
    }

    this.loadChart();
  }

  loadChart() {
    this.totalValue = 0;
    this.loading = true;
    this.ChartData = [];
    this.ChartColors = [{}];
    if (this.selectedMoments) {
      this.currentSelectedDate = new Date(this.selectedMoments[0]);
    }

    if (this.isPower) {
      this.energyService
        .getPowerMetering(
          this.activeView,
          this.datePipe.transform(this.currentSelectedDate, "yyyy-MM-dd"),
          this.datePipe.transform(this.getRespectiveEndDate(), "yyyy-MM-dd")
        )
        .subscribe(
          (chart) => {
            if (typeof chart !== "boolean") {
              this.maxPowerMeasured.emit(chart.maximumValueOnPeriod);
              this.ChartLabels = this.getLabels(
                this.activeView,
                this.getRawLabels(chart)
              );
              this.values = this.getPowerValues(chart);
              if (this.ChartData.length < 1) {
                this.ChartData.push({
                  data: Array.from(this.values.values()),
                  label: this.generalService.translate.instant("Power"),
                  borderWidth: 0,
                  stack: "1",
                });
                this.powerChartColors = [
                  {
                    backgroundColor: this.gradient,
                    borderColor: "rgba(234, 82, 75, 0.8)",
                    hoverBackgroundColor: "rgba(234, 82, 75, 0.8) ",
                  },
                ];
                /**Contracted Power */
                this.houseService
                  .getHouseContractedPower(
                    this.sessionStateService.getHouse().houseId
                  )
                  .subscribe((value) => {
                    this.contractedPower = value.contractedPower;
                    this.contractedPowerUnit = value.unit;
                    this.ChartData.push({
                      data: this.iteratePower(
                        this.contractedPower,
                        this.ChartLabels.length
                      ),
                      label: this.generalService.translate.instant(
                        "Contracted Power"
                      ),
                      borderWidth: 2,
                      stack: "1",
                      borderColor: "rgba(234, 82, 75, 1)",
                      type: "line",
                      fill: false,
                      pointStyle: "line",
                    });
                    this.loading = false;
                  });
              }
            } else {
              this.refreshVisualDataRepresentation();
              this.loading = false;
            }
            this.refreshVisualDataRepresentation();
          },
          (err) => {
            this.refreshVisualDataRepresentation();
            this.loading = false;
          }
        );
    } else if (this.isGeneration) {
      this.devicesService
        .getMetering(
          this.device.getDeviceId(),
          this.device.getModuleId(),
          this.activeView,
          this.datePipe.transform(this.currentSelectedDate, "yyyy-MM-dd"),
          this.datePipe.transform(this.getRespectiveEndDate(), "yyyy-MM-dd"),
          this.device
            .getHistoricVars()
            ["supported"].includes("ActiveEnergyProduced")
            ? "ActiveEnergyProduced"
            : "ActiveEnergyInjected"
        )
        .subscribe(
          (chart) => {
            if (typeof chart !== "boolean") {
              this.totalsOutput.emit(["production", chart.totals]);
              this.totals = chart.totals;
              this.ChartLabels = this.getLabels(
                this.activeView,
                this.getRawLabels(chart)
              );
              this.values = this.getEnergyChartValues(
                this.mode,
                chart.energyChart,
                true
              );
              if (
                this.device
                  .getHistoricVars()
                  ["supported"].includes("ActiveEnergyInjected") ||
                this.device
                  .getHistoricVars()
                  ["supported"].includes("ActiveEnergyProduced")
              ) {
                if (this.ChartData.length < 1) {
                  this.ChartData.push({
                    data: Array.from(this.values[0]),
                    label: this.isPrediction
                      ? this.generalService.translate.instant("Production")
                      : this.generalService.translate.instant("Production"),
                    borderWidth: 0,
                    stack: "1",
                    backgroundColor: this.iterateColor("rgba(96, 187, 242, 1)"),
                    hoverBackgroundColor: this.iterateColor(
                      "rgba(199,232,250,1)"
                    ),
                  });
                }
                this.totalValue = this.getTotal();
                this.loading = false;
                this.refreshVisualDataRepresentation();
              } else {
                this.totalsOutput.emit(["reset"]);
                this.loading = false;
                this.refreshVisualDataRepresentation();
              }
            }
          },
          (err) => {
            this.totalsOutput.emit(["reset"]);
            this.loading = false;
            this.refreshVisualDataRepresentation();
          }
        );
    } else if (!this.isPrediction) {
      this.devicesService
        .getMetering(
          this.device.getDeviceId(),
          this.device.getModuleId(),
          this.activeView,
          this.datePipe.transform(this.currentSelectedDate, "yyyy-MM-dd"),
          this.datePipe.transform(this.getRespectiveEndDate(), "yyyy-MM-dd"),
          "ActiveEnergyConsumed"
        )
        .subscribe(
          (chart) => {
            if (typeof chart !== "boolean") {
              this.totalsOutput.emit(["consumption", chart.totals]);
              this.totals = chart.totals;
              this.ChartLabels = this.getLabels(
                this.activeView,
                this.getRawLabels(chart)
              );
              this.values = this.getEnergyChartValues(
                this.mode,
                chart.energyChart,
                true
              );

              if (
                this.device
                  .getHistoricVars()
                  ["supported"].includes("ActiveEnergyConsumed")
              ) {
                if (
                  this.normalSchedules &&
                  this.totals &&
                  this.totals["value"]["N"]
                ) {
                  if (this.ChartData.length < 1) {
                    this.ChartData.push({
                      data: Array.from(this.values[0]),
                      label: this.generalService.translate.instant("Normal"),
                      borderWidth: 0,
                      stack: "1",
                      backgroundColor: this.iterateColor(
                        "rgba(234, 82, 75, 1)"
                      ),
                      hoverBackgroundColor: this.iterateColor(
                        "rgba(253,129,124,1)"
                      ),
                    });
                  }
                }
                if (
                  this.economicSchedules &&
                  this.totals &&
                  this.totals["value"]["E"]
                ) {
                  if (this.ChartData.length < 2) {
                    this.ChartData.push({
                      data: Array.from(this.values[1]),
                      label: this.generalService.translate.instant("Economic"),
                      borderWidth: 0,
                      stack: "1",
                      backgroundColor: this.iterateColor("rgba(250,153,116,1)"),
                      hoverBackgroundColor: this.iterateColor(
                        "rgba(251,173,143,1)"
                      ),
                    });
                  }
                }
                if (
                  this.superEconomicSchedules &&
                  this.totals &&
                  this.totals["value"]["SE"]
                ) {
                  if (this.ChartData.length < 3) {
                    this.ChartData.push({
                      data: Array.from(this.values[2]),
                      label: this.generalService.translate.instant(
                        "Super Economic"
                      ),
                      borderWidth: 0,
                      stack: "1",
                      backgroundColor: this.iterateColor("rgba(255,197,176,1)"),
                      hoverBackgroundColor: this.iterateColor(
                        "rgba(255,210,193,1)"
                      ),
                    });
                  }
                }
                /**Spain */
                if (this.isSpainCountry) {
                  this.devicesService
                    .getCostPerKwh(
                      this.activeView,
                      this.datePipe.transform(
                        this.currentSelectedDate,
                        "yyyy-MM-dd"
                      )
                    )
                    .subscribe((costReadings) => {
                      this.ChartData.push({
                        data: this.getcostPerkWhChart(costReadings),
                        label: this.generalService.translate.instant(
                          "Energy Price"
                        ),
                        borderWidth: 0,
                        stack: "1",
                        borderColor: "rgba(174, 83, 255, 1)",
                        type: "line",
                        fill: false,
                        pointStyle: "line",
                      });
                      this.loading = false;
                      this.refreshVisualDataRepresentation();
                    });
                }
              } else {
                if (this.ChartData.length < 1) {
                  this.ChartData.push({
                    data: Array.from(this.values[0]),
                    label: this.generalService.translate.instant("Generation"),
                    borderWidth: 0,
                    stack: "1",
                    backgroundColor: this.iterateColor(
                      "rgba(160, 215, 248, 1)"
                    ),
                    hoverBackgroundColor: this.iterateColor(
                      "rgba(199,232,250,1)"
                    ),
                  });
                }
              }

              this.totalValue = this.getTotal();
              this.maxValue = this.getMaxValue();
              if (this.consumptionAndGeneration) {
                this.additionalResumeReadingOptions();
              } else {
                if (!this.isSpainCountry) {
                  this.loading = false;
                  this.refreshVisualDataRepresentation();
                }
              }
            } else {
              this.refreshVisualDataRepresentation();
              this.loading = false;
            }
          },
          (err) => {
            this.totalsOutput.emit(["reset"]);
            this.additionalResumeReadingOptions();
            this.refreshVisualDataRepresentation();
            this.loading = false;
          }
        );
    } else {
      this.currentSelectedDate = new Date(
        this.currentSelectedDate.getFullYear(),
        this.currentSelectedDate.getMonth(),
        this.currentSelectedDate.getDate()
      );
      this.energyService
        .getPredictionGraph(this.sessionStateService.getHouse().houseId)
        .subscribe(
          (chart) => {
            if (typeof chart !== "boolean") {
              this.startBillingDate = moment(chart.startBillingDate).format(
                "DD MMM YYYY"
              );
              this.endBillingDate = moment(chart.endBillingDate).format(
                "DD MMM YYYY"
              );
              this.ChartLabels = this.getPredictionLabels(chart);
              this.ChartData.push({
                data: Array.from(this.getPredictionValues(chart)[0]),
                label: this.generalService.translate.instant("Consumption"),
                borderWidth: 0,
                stack: "1",
                backgroundColor: this.iterateColor("rgba(234, 82, 75, 1)"),
                hoverBackgroundColor: this.iterateColor("rgba(253,129,124,1)"),
              });
              this.ChartData.push({
                data: Array.from(this.getPredictionValues(chart)[1]),
                label: this.generalService.translate.instant("Prediction"),
                borderWidth: 0,
                stack: "1",
                backgroundColor: this.iterateColor("rgba(250,153,116,1)"),
                hoverBackgroundColor: this.iterateColor("rgba(251,173,143,1)"),
              });
              this.loading = false;
            } else {
              this.refreshVisualDataRepresentation();
              this.loading = false;
            }
          },
          (err) => {
            this.refreshVisualDataRepresentation();
            this.loading = false;
          }
        );
    }
  }

  getEnergyChartValues(
    measure: string,
    response: Array<any>,
    justConsumption: boolean
  ): Array<Array<string>> {
    let dataNormal: Array<string> = new Array();
    let dataEco: Array<string> = new Array();
    let dataSuperEco: Array<string> = new Array();
    let dataAux: Array<string> = new Array();
    const presentValuesNormal: Map<string, any> = new Map<string, any>();
    const presentValuesEco: Map<string, any> = new Map<string, any>();
    const presentValuesSuperEco: Map<string, any> = new Map<string, any>();
    const presentValuesD: Map<string, any> = new Map<string, any>();
    let auxDate: Date = new Date();
    if (response) {
      response.forEach((entry) => {
        const dateAux: string = entry.date;
        const yearMonthDay = dateAux.split(" ")[0].split("-");
        const year = +yearMonthDay[0];
        const month = +yearMonthDay[1] - 1;
        const day = +yearMonthDay[2];
        if (yearMonthDay[2] == null) {
          auxDate = new Date(year, month);
        } else if (dateAux.split(" ")[1] != null) {
          const hourMinSec = dateAux.split(" ")[1].split(":");
          const hour = +hourMinSec[0];
          const min = +hourMinSec[1];
          const sec = +hourMinSec[2];
          auxDate = new Date(year, month, day, hour, min, sec);
        } else {
          auxDate = new Date(year, month, day);
        }

        if (measure !== "Eur") {
          if (this.activeView === "H") {
            if (entry.value.N) {
              presentValuesNormal.set(
                String(auxDate.getHours()),
                Number(entry.value.N).toFixed(3)
              );
            }
            if (entry.value.E) {
              presentValuesEco.set(
                String(auxDate.getHours()),
                Number(entry.value.E).toFixed(3)
              );
            }
            if (entry.value.SE) {
              presentValuesSuperEco.set(
                String(auxDate.getHours()),
                Number(entry.value.SE).toFixed(3)
              );
            }
            if (entry.value.D) {
              presentValuesD.set(
                String(auxDate.getHours()),
                Number(entry.value.D).toFixed(3)
              );
            }
          } else if (this.activeView === "Q") {
            if (entry.value.N) {
              presentValuesNormal.set(
                String(auxDate.getHours() + ":" + auxDate.getMinutes()),
                Number(entry.value.N).toFixed(3)
              );
            }
            if (entry.value.E) {
              presentValuesEco.set(
                String(auxDate.getHours() + ":" + auxDate.getMinutes()),
                Number(entry.value.E).toFixed(3)
              );
            }
            if (entry.value.SE) {
              presentValuesSuperEco.set(
                String(auxDate.getHours() + ":" + auxDate.getMinutes()),
                Number(entry.value.SE).toFixed(3)
              );
            }
            if (entry.value.D) {
              presentValuesD.set(
                String(auxDate.getHours() + ":" + auxDate.getMinutes()),
                Number(entry.value.D).toFixed(3)
              );
            }
          } else if (this.activeView === "D") {
            if (entry.value.N) {
              presentValuesNormal.set(
                String(auxDate.getDate()),
                Number(entry.value.N).toFixed(3)
              );
            }
            if (entry.value.E) {
              presentValuesEco.set(
                String(auxDate.getDate()),
                Number(entry.value.E).toFixed(3)
              );
            }
            if (entry.value.SE) {
              presentValuesSuperEco.set(
                String(auxDate.getDate()),
                Number(entry.value.SE).toFixed(3)
              );
            }
            if (entry.value.D) {
              presentValuesD.set(
                String(auxDate.getDate()),
                Number(entry.value.D).toFixed(3)
              );
            }
          } else if (this.activeView === "M") {
            if (entry.value.N) {
              presentValuesNormal.set(
                String(auxDate.getMonth() + 1) + "#" + auxDate.getFullYear(),
                Number(entry.value.N).toFixed(3)
              );
            }
            if (entry.value.E) {
              presentValuesEco.set(
                String(auxDate.getMonth() + 1) + "#" + auxDate.getFullYear(),
                Number(entry.value.E).toFixed(3)
              );
            }
            if (entry.value.SE) {
              presentValuesSuperEco.set(
                String(auxDate.getMonth() + 1) + "#" + auxDate.getFullYear(),
                Number(entry.value.SE).toFixed(3)
              );
            }
            if (entry.value.D) {
              presentValuesD.set(
                String(auxDate.getMonth() + 1) + "#" + auxDate.getFullYear(),
                Number(entry.value.D).toFixed(3)
              );
            }
          }
        } else {
          if (this.activeView === "H") {
            if (entry.cost.N) {
              presentValuesNormal.set(
                String(auxDate.getHours()),
                this.lessMinValue(Number(entry.cost.N).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.N).toFixed(3)
              );
            }
            if (entry.cost.E) {
              presentValuesEco.set(
                String(auxDate.getHours()),
                this.lessMinValue(Number(entry.cost.E).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.E).toFixed(3)
              );
            }
            if (entry.cost.SE) {
              presentValuesSuperEco.set(
                String(auxDate.getHours()),
                this.lessMinValue(Number(entry.cost.SE).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.SE).toFixed(3)
              );
            }
            if (entry.cost.D) {
              presentValuesD.set(
                String(auxDate.getHours()),
                this.lessMinValue(Number(entry.cost.D).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.D).toFixed(3)
              );
            }
          } else if (this.activeView === "Q") {
            if (entry.cost.N) {
              presentValuesNormal.set(
                String(auxDate.getHours() + ":" + auxDate.getMinutes()),
                this.lessMinValue(Number(entry.cost.N).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.N).toFixed(3)
              );
            }
            if (entry.cost.E) {
              presentValuesEco.set(
                String(auxDate.getHours() + ":" + auxDate.getMinutes()),
                this.lessMinValue(Number(entry.cost.E).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.E).toFixed(3)
              );
            }
            if (entry.cost.SE) {
              presentValuesSuperEco.set(
                String(auxDate.getHours() + ":" + auxDate.getMinutes()),
                this.lessMinValue(Number(entry.cost.SE).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.SE).toFixed(3)
              );
            }
            if (entry.cost.D) {
              presentValuesD.set(
                String(auxDate.getHours() + ":" + auxDate.getMinutes()),
                this.lessMinValue(Number(entry.cost.D).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.D).toFixed(3)
              );
            }
          } else if (this.activeView === "D") {
            if (entry.cost.N) {
              presentValuesNormal.set(
                String(auxDate.getDate()),
                this.lessMinValue(Number(entry.cost.N).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.N).toFixed(3)
              );
            }
            if (entry.cost.E) {
              presentValuesEco.set(
                String(auxDate.getDate()),
                this.lessMinValue(Number(entry.cost.E).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.E).toFixed(3)
              );
            }
            if (entry.cost.SE) {
              presentValuesSuperEco.set(
                String(auxDate.getDate()),
                this.lessMinValue(Number(entry.cost.SE).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.SE).toFixed(3)
              );
            }
            if (entry.cost.D) {
              presentValuesD.set(
                String(auxDate.getDate()),
                this.lessMinValue(Number(entry.cost.D).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.D).toFixed(3)
              );
            }
          } else if (this.activeView === "M") {
            if (entry.cost.N) {
              presentValuesNormal.set(
                String(auxDate.getMonth() + 1) + "#" + auxDate.getFullYear(),
                this.lessMinValue(Number(entry.cost.N).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.N).toFixed(3)
              );
            }
            if (entry.cost.E) {
              presentValuesEco.set(
                String(auxDate.getMonth() + 1) + "#" + auxDate.getFullYear(),
                this.lessMinValue(Number(entry.cost.E).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.E).toFixed(3)
              );
            }
            if (entry.cost.SE) {
              presentValuesSuperEco.set(
                String(auxDate.getMonth() + 1) + "#" + auxDate.getFullYear(),
                this.lessMinValue(Number(entry.cost.SE).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.SE).toFixed(3)
              );
            }
            if (entry.cost.D) {
              presentValuesD.set(
                String(auxDate.getMonth() + 1) + "#" + auxDate.getFullYear(),
                this.lessMinValue(Number(entry.cost.D).toFixed(3))
                  ? 0.001
                  : Number(entry.cost.D).toFixed(3)
              );
            }
          }
        }
      });
    }
    if (justConsumption) {
      dataNormal = this.addParsedValues(presentValuesNormal, auxDate);
      dataEco = this.addParsedValues(presentValuesEco, auxDate);
      dataSuperEco = this.addParsedValues(presentValuesSuperEco, auxDate);
    }
    dataAux = this.addParsedValues(presentValuesD, auxDate);

    if (this.isGeneration) {
      return [dataAux];
    } else {
      return [dataNormal, dataEco, dataSuperEco, dataAux];
    }
  }
  lessMinValue(value) {
    return value > 0 && value < 0.001;
  }

  iterateColor(color: string): string[] {
    const array: string[] = new Array();
    for (let i = 0; i < 250; i++) {
      array.push(color);
    }
    return array;
  }

  iteratePower(value: string, times: number): string[] {
    const array: string[] = new Array();
    for (let i = 0; i < times; i++) {
      array.push(value);
    }
    return array;
  }

  getLanguage() {
    return this.sessionStateService.getLang();
  }

  getLabels(activeView: string, rawLabels: Array<string>): string[] {
    const labels: string[] = new Array();
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    /**Day View*/
    if (!this.selectedMoments) {
      if (activeView === "H") {
        for (let h = 0; h < 24; h++) {
          let hour: string = String(h);
          if (hour.length === 1) {
            hour = "0" + hour;
          }
          labels.push(String(hour).concat("h"));
        }
        /**15m View*/
      }
      if (activeView === "Q") {
        for (let h = 0; h < 24; h++) {
          let hour: string = String(h);
          if (hour.length === 1) {
            hour = "0" + hour;
          }
          for (let m = 0; m < 60; m = m + 15) {
            let minute: string = String(m);
            if (minute.length === 1) {
              minute = "0" + minute;
            }
            labels.push(hour + ":" + minute);
          }
        }
        /**Month View*/
      } else if (activeView === "D") {
        const auxDate: Date = new Date(rawLabels[0]);
        const lastDayOfMonth = new Date(
          auxDate.getFullYear(),
          auxDate.getMonth() + 1,
          0
        ).getDate();
        for (let d = 1; d < lastDayOfMonth + 1; d++) {
          labels.push(String(d));
        }
        /**Anual View*/
      } else if (activeView === "M") {
        for (let i = 0; i < 12; i++) {
          labels.push(monthNames[i].toString());
        }
      }
    } else {
      const dateF: Date = new Date(this.selectedMoments[0]);
      let dateT: Date = new Date();
      if (this.selectedMoments[1]) {
        dateT = new Date(this.selectedMoments[1]);
      } else {
        dateT = new Date(this.selectedMoments[0]);
      }
      const interval: number =
        Math.abs(dateT.getTime() - dateF.getTime()) / (1000 * 3600 * 24);
      if (this.activeView !== "Q") {
        if (interval < 1) {
          for (let h = 0; h < 24; h++) {
            let hour: string = String(h);
            if (hour.length === 1) {
              hour = "0" + hour;
            }
            labels.push(String(hour).concat("h"));
          }
        } else if (interval >= 30) {
          const startMonth = dateF.getMonth();
          const endMonth = dateT.getMonth();
          if (interval < 365) {
            const otherYear = startMonth >= endMonth ? true : false;
            if (otherYear) {
              for (let m = startMonth; m <= 11; m++) {
                labels.push(monthNames[m].toString());
              }
              for (let m = 0; m <= endMonth; m++) {
                labels.push(monthNames[m].toString());
              }
            } else {
              for (let m = startMonth; m <= endMonth || otherYear; m++) {
                labels.push(monthNames[m].toString());
              }
            }
          } else {
            for (let yN = 0; yN <= interval / 365; yN++) {
              for (
                let m = yN === 0 ? startMonth : 0;
                (m <= 11 && yN + 1 < interval / 365) ||
                (yN > 0 && m <= endMonth);
                m++
              ) {
                labels.push(monthNames[m].toString());
              }
            }
          }
        } else {
          const dateFrom = dateF.getDate();
          const dateTo = dateT.getDate();
          const auxDate: Date = new Date(rawLabels[0]);
          const lastDayOfMonth = new Date(
            auxDate.getFullYear(),
            auxDate.getMonth() + 1,
            0
          ).getDate();
          if (interval > Math.abs(dateFrom - lastDayOfMonth)) {
            for (let d = dateFrom; d < lastDayOfMonth + 1; d++) {
              labels.push(String(d));
            }
            for (let j = 1; j < dateTo + 1; j++) {
              labels.push(String(j));
            }
          } else {
            for (let d = dateFrom; d < dateTo + 1; d++) {
              labels.push(String(d));
            }
          }
        }
      } else {
        for (let h = 0; h < 24; h++) {
          let hour: string = String(h);
          if (hour.length === 1) {
            hour = "0" + hour;
          }
          for (let m = 0; m < 60; m = m + 15) {
            let minute: string = String(m);
            if (minute.length === 1) {
              minute = "0" + minute;
            }
            labels.push(hour + ":" + minute);
          }
        }
      }
    }
    let translatedLabels = [];
    labels.forEach((l) => {
      translatedLabels.push(this.generalService.translate.instant(l));
    });
    return translatedLabels;
  }

  minuteSelection() {
    if (this.activeView !== "Q") {
      this.previousView = this.activeView;
      this.activeView = "Q";
      this.loadChart();
    }
  }

  daySelection(hourView: boolean, reset?: boolean) {
    this.dateChange.emit(true);
    if (this.activeView !== "H" || this.selectedMoments || reset) {
      if (
        (!this.selectedMoments || this.activeView === "Custom" || hourView) &&
        !this.loading
      ) {
        if (reset) {
          this.currentSelectedDate = new Date(Date.now());
          this.getSelectedDate();
        }
        this.activeView = "H";
      }
      this.loadChart();
    }
  }

  monthSelection() {
    this.dateChange.emit(true);
    if (this.activeView !== "D") {
      const present = new Date(Date.now());
      if (
        (!this.selectedMoments || this.activeView === "Custom") &&
        (!this.loading || this.isPrediction)
      ) {
        this.nextArrowPossible = false;
        this.currentSelectedDate = new Date(
          present.getFullYear(),
          present.getMonth(),
          1
        );
        this.activeView = "D";
      }
      this.loadChart();
    }
  }

  yearSelection() {
    this.dateChange.emit(true);
    if (this.activeView !== "M") {
      const present = new Date(Date.now());
      if (
        (!this.selectedMoments || this.activeView === "Custom") &&
        !this.loading
      ) {
        this.nextArrowPossible = false;
        this.currentSelectedDate = new Date(present.getFullYear(), 0, 1);
        this.activeView = "M";
      }
      this.loadChart();
    }
  }

  refreshVisualDataRepresentation() {
    this.selectedDate = this.getSelectedDate();
  }

  isToday(date: Date): boolean {
    const today = new Date(Date.now());
    return (
      today.getDate() === date.getDate() &&
      today.getMonth() === date.getMonth() &&
      today.getFullYear() === date.getFullYear()
    );
  }

  getSelectedDate(): string {
    if (this.selectedMoments) {
      return "Custom";
    }
    if (this.activeView === "H" || this.activeView === "Q") {
      if (this.isToday(this.currentSelectedDate)) {
        return "Today";
      } else {
        return this.datePipe.transform(this.currentSelectedDate, "yyyy-MM-dd");
      }
    } else if (this.activeView === "D") {
      return this.datePipe.transform(this.currentSelectedDate, "LLLL");
    } else if (this.activeView === "M") {
      return this.datePipe.transform(this.currentSelectedDate, "yyyy");
    }
  }

  moveDateBack() {
    this.dateChange.emit(true);
    if (!this.loading) {
      this.ChartData = [];
      if (!this.selectedMoments) {
        if (!this.nextArrowPossible) {
          this.nextArrowPossible = !this.nextArrowPossible;
        }
        if (this.activeView === "H" || this.activeView === "Q") {
          this.currentSelectedDate = new Date(
            this.currentSelectedDate.getFullYear(),
            this.currentSelectedDate.getMonth(),
            this.currentSelectedDate.getDate() - 1
          );
        }
        if (this.activeView === "D") {
          this.currentSelectedDate = new Date(
            this.currentSelectedDate.getFullYear(),
            this.currentSelectedDate.getMonth() - 1,
            this.currentSelectedDate.getDate()
          );
        }
        if (this.activeView === "M") {
          this.currentSelectedDate = new Date(
            this.currentSelectedDate.getFullYear() - 1,
            this.currentSelectedDate.getMonth(),
            this.currentSelectedDate.getDate()
          );
        }
        this.loadChart();
      }
    }
  }

  moveDateFoward() {
    this.dateChange.emit(true);
    if (!this.loading) {
      this.ChartData = [];
      const today: Date = new Date(Date.now());
      let fowardDate: Date = new Date();
      // Foward verifications to allow the arrow to be presented
      if (this.activeView === "H" || this.activeView === "Q") {
        fowardDate = new Date(
          this.currentSelectedDate.getFullYear(),
          this.currentSelectedDate.getMonth(),
          this.currentSelectedDate.getDate() + 2
        );
      }
      if (this.activeView === "D") {
        fowardDate = new Date(
          this.currentSelectedDate.getFullYear(),
          this.currentSelectedDate.getMonth() + 2,
          this.currentSelectedDate.getDate()
        );
      }
      if (this.activeView === "M") {
        fowardDate = new Date(
          this.currentSelectedDate.getFullYear() + 2,
          this.currentSelectedDate.getMonth(),
          this.currentSelectedDate.getDate()
        );
      }

      if (fowardDate.valueOf() > today.valueOf()) {
        this.nextArrowPossible = false;
      }
      if (!this.selectedMoments) {
        const minChange: Date = new Date(
          this.currentSelectedDate.getFullYear(),
          this.currentSelectedDate.getMonth(),
          this.currentSelectedDate.getDate() + 1
        );
        if (minChange.valueOf() < today.valueOf()) {
          if (this.activeView === "H" || this.activeView === "Q") {
            this.currentSelectedDate = new Date(
              this.currentSelectedDate.getFullYear(),
              this.currentSelectedDate.getMonth(),
              this.currentSelectedDate.getDate() + 1
            );
          }
          if (this.activeView === "D") {
            this.currentSelectedDate = new Date(
              this.currentSelectedDate.getFullYear(),
              this.currentSelectedDate.getMonth() + 1,
              this.currentSelectedDate.getDate()
            );
          }
          if (this.activeView === "M") {
            this.currentSelectedDate = new Date(
              this.currentSelectedDate.getFullYear() + 1,
              this.currentSelectedDate.getMonth(),
              this.currentSelectedDate.getDate()
            );
          }
          this.loadChart();
        } else {
          this.nextArrowPossible = false;
        }
      }
    }
  }

  getRespectiveEndDate(): Date {
    if (this.isPrediction) {
      return new Date(
        this.currentSelectedDate.getFullYear(),
        this.currentSelectedDate.getMonth() + 1,
        this.currentSelectedDate.getDate()
      );
    }
    if (!this.selectedMoments) {
      if (this.activeView === "H" || this.activeView === "Q") {
        return new Date(
          this.currentSelectedDate.getFullYear(),
          this.currentSelectedDate.getMonth(),
          this.currentSelectedDate.getDate()
        );
      }
      if (this.activeView === "D") {
        return new Date(
          this.currentSelectedDate.getFullYear(),
          this.currentSelectedDate.getMonth() + 1,
          this.currentSelectedDate.getDate() - 1
        );
      }
      if (this.activeView === "M") {
        const yearEndDate = new Date(
          this.currentSelectedDate.getFullYear() + 1,
          this.currentSelectedDate.getMonth(),
          this.currentSelectedDate.getDate() - 1
        );
        return yearEndDate;
      }
    } else {
      if (this.selectedMoments[1] !== null) {
        return new Date(
          this.selectedMoments[1].getFullYear(),
          this.selectedMoments[1].getMonth(),
          this.selectedMoments[1].getDate()
        );
      } else {
        return new Date(
          this.selectedMoments[0].getFullYear(),
          this.selectedMoments[0].getMonth(),
          this.selectedMoments[0].getDate()
        );
      }
    }
  }

  energyModeSelection() {
    if (!this.loading && this.mode !== "kWh") {
      this.mode = "kWh";
      this.modeOutput.emit(this.mode);
      this.loadChart();
    }
  }

  moneyModeSelection() {
    if (!this.loading && this.mode !== "Eur") {
      this.mode = "Eur";
      this.modeOutput.emit(this.mode);
      this.loadChart();
    }
  }

  allTariffsActive(): boolean {
    return (
      this.normalSchedules &&
      this.economicSchedules &&
      this.superEconomicSchedules
    );
  }

  activateAllSchedules() {
    if (!this.allSchedules) {
      this.normalSchedules = true;
      this.economicSchedules = true;
      this.superEconomicSchedules = true;
      this.selfConsumptionSchedules = true;
      this.allSchedules = true;
      this.refreshVisualDataRepresentation();
      this.loadChart();
    }
  }

  minimumScheduleActive(): boolean {
    return (
      (this.normalSchedules && this.economicSchedules) ||
      (this.normalSchedules && this.selfConsumptionSchedules) ||
      (this.supliedtoGridSchedules && this.selfConsumptionSchedules) ||
      (this.economicSchedules && this.selfConsumptionSchedules) ||
      (this.economicSchedules && this.supliedtoGridSchedules) ||
      (this.normalSchedules && this.supliedtoGridSchedules) ||
      (this.normalSchedules && this.superEconomicSchedules) ||
      (this.superEconomicSchedules && this.economicSchedules) ||
      (this.superEconomicSchedules && this.supliedtoGridSchedules) ||
      (this.superEconomicSchedules && this.selfConsumptionSchedules)
    );
  }

  toggleNormalSchedule() {
    if (this.totals && this.totals["value"]["N"]) {
      if (this.minimumScheduleActive() || !this.normalSchedules) {
        this.normalSchedules = !this.normalSchedules;
        if (this.allSchedules) {
          this.allSchedules = false;
        } else if (this.allTariffsActive()) {
          this.allSchedules = true;
        }
        this.loadChart();
      }
    }
  }

  toggleEconomicSchedule() {
    if (this.totals && this.totals["value"]["E"]) {
      if (this.minimumScheduleActive() || !this.economicSchedules) {
        this.economicSchedules = !this.economicSchedules;
        if (this.allSchedules) {
          this.allSchedules = false;
        } else if (this.allTariffsActive()) {
          this.allSchedules = true;
        }
        this.loadChart();
      }
    }
  }

  toggleSuperEconomicSchedule() {
    if (this.totals && this.totals["value"]["SE"]) {
      if (this.minimumScheduleActive() || !this.superEconomicSchedules) {
        this.superEconomicSchedules = !this.superEconomicSchedules;
        if (this.allSchedules) {
          this.allSchedules = false;
        } else if (this.allTariffsActive()) {
          this.allSchedules = true;
        }
        this.loadChart();
      }
    }
  }

  toggleSuppliedtoGridSchedule() {
    if (this.totalsAux[0] && this.totalsAux[0]["value"]["D"]) {
      if (this.minimumScheduleActive() || !this.supliedtoGridSchedules) {
        this.supliedtoGridSchedules = !this.supliedtoGridSchedules;
        if (this.allSchedules) {
          this.allSchedules = false;
        } else if (this.allTariffsActive()) {
          this.allSchedules = true;
        }
        this.loadChart();
      }
    }
  }

  toggleSelfConsumptionSchedule() {
    if (this.totalsAux[1] && this.totalsAux[1]["value"]["D"]) {
      if (this.minimumScheduleActive() || !this.selfConsumptionSchedules) {
        this.selfConsumptionSchedules = !this.selfConsumptionSchedules;
        if (this.allSchedules) {
          this.allSchedules = false;
        } else if (this.allTariffsActive()) {
          this.allSchedules = true;
        }
        this.loadChart();
      }
    }
  }

  clearFilter() {
    this.selectedMoments = null;
    if (this.previousViewCustom === "Q") {
      this.minuteSelection();
    } else if (this.previousViewCustom === "H") {
      this.daySelection(false, true);
    } else if (this.previousViewCustom === "D") {
      this.monthSelection();
    } else if (this.previousViewCustom === "M") {
      this.yearSelection();
    }
    this.refreshVisualDataRepresentation();
    this.loadChart();
  }

  formatDates(dateFrom: string, dateTo: string): string {
    const dateF: Date = new Date(dateFrom);
    const dateT: Date = new Date(dateTo);
    if (dateTo) {
      return (
        this.generalService.translate.instant("From: ") +
        this.datePipe.transform(dateF, "yyyy-MM-dd") +
        this.generalService.translate.instant(" To: ") +
        this.datePipe.transform(dateT, "yyyy-MM-dd")
      );
    } else {
      return (
        this.generalService.translate.instant("From: ") +
        this.datePipe.transform(dateF, "yyyy-MM-dd") +
        this.generalService.translate.instant(" To: ") +
        this.datePipe.transform(dateF, "yyyy-MM-dd")
      );
    }
  }

  onChange(selectedMoments) {
    if (this.selectedMoments.length !== 0) {
      this.previousViewCustom = this.activeView;
      this.activeView = "Custom";
      this.selectedDate = this.getSelectedDate();
      const dateF: Date = new Date(this.selectedMoments[0]);
      let dateT: Date = new Date();
      if (this.selectedMoments[1]) {
        dateT = new Date(this.selectedMoments[1]);
      } else {
        dateT = new Date(this.selectedMoments[0]);
      }
      this.calculateView(dateF, dateT);
    } else {
      this.selectedMoments = null;
    }
  }

  calculateView(dateFrom: Date, dateTo: Date) {
    const interval: number =
      Math.abs(dateTo.getTime() - dateFrom.getTime()) / (1000 * 3600 * 24);
    if (interval < 1) {
      this.daySelection(false);
    } else if (interval >= 30) {
      this.yearSelection();
    } else {
      this.monthSelection();
    }
  }

  getMaxValue() {
    let max = 0;
    if (this.isGeneration) {
      const generationValues: number[] = Array.from(this.values[0].values());
      max = Math.max.apply(Math, generationValues);
    } else {
      const normalValues: number[] = Array.from(this.values[0].values());
      const economicValues: number[] = Array.from(this.values[1].values());
      const superEconomicValues: number[] = Array.from(this.values[2].values());

      if (this.normalSchedules) {
        max = Math.max.apply(Math, normalValues);
      }
      if (this.economicSchedules) {
        max = Math.max.apply(Math, economicValues.concat(max));
      }
      if (this.superEconomicSchedules) {
        max = Math.max.apply(Math, superEconomicValues.concat(max));
      }
    }
    return max;
  }

  cleanArray(actual) {
    const newArray = new Array();
    for (let i = 0; i < actual.length; i++) {
      if (actual[i]) {
        newArray.push(actual[i]);
      }
    }
    return newArray;
  }

  getTotal(): number {
    let total = 0;
    if (this.isGeneration) {
      const generationlValues: number[] = Array.from(this.values[0].values());
      generationlValues.forEach((generationValue) => {
        total =
          total +
          (generationValue && this.normalSchedules
            ? Number(generationValue)
            : 0);
      });
    } else {
      const normalValues: number[] = Array.from(this.values[0].values());
      const economicValues: number[] = Array.from(this.values[1].values());
      const superEconomicValues: number[] = Array.from(this.values[2].values());
      normalValues.forEach((normalValue) => {
        total =
          normalValue && this.normalSchedules
            ? total + Number(normalValue)
            : total + 0;
      });
      economicValues.forEach((economicValue) => {
        total =
          economicValue && this.economicSchedules
            ? total + Number(economicValue)
            : total + 0;
      });
      superEconomicValues.forEach((superEconomicValue) => {
        total =
          superEconomicValue && this.superEconomicSchedules
            ? total + Number(superEconomicValue)
            : total + 0;
      });
    }
    return total;
  }

  additionalResumeReadingOptions() {
    if (this.selfConsumptionSchedules) {
      this.devicesService
        .getMetering(
          this.device.getDeviceId(),
          this.device.getModuleId(),
          this.activeView,
          this.datePipe.transform(this.currentSelectedDate, "yyyy-MM-dd"),
          this.datePipe.transform(this.getRespectiveEndDate(), "yyyy-MM-dd"),
          "ActiveEnergySelfconsumed"
        )
        .subscribe(
          (selfMetering) => {
            this.totalsOutput.emit(["self", selfMetering.totals]);
            this.ChartLabels = this.getLabels(
              this.activeView,
              this.getRawLabels(selfMetering)
            );
            this.totalsAux[1] = selfMetering.totals;
            this.values = this.getEnergyChartValues(
              this.mode,
              selfMetering.energyChart,
              false
            );
            if (
              this.selfConsumptionSchedules &&
              this.totalsAux[1] &&
              this.totalsAux[1]["value"]["D"]
            ) {
              this.ChartData.push({
                data: Array.from(this.values[3].values()),
                label: this.generalService.translate.instant(
                  "Self-Consumption"
                ),
                borderWidth: 0,
                stack: "1",
                backgroundColor: this.iterateColor("rgba(96, 187, 242, 1)"),
                hoverBackgroundColor: this.iterateColor("rgba(199,232,250,1)"),
              });
            }
            if (!this.supliedtoGridSchedules) {
              this.loading = false;
            } else {
              this.getInjectionValues();
            }
          },
          (err) => {
            this.getInjectionValues();
            this.refreshVisualDataRepresentation();
          }
        );
    } else {
      if (!this.supliedtoGridSchedules) {
        this.loading = false;
      } else {
        this.getInjectionValues();
      }
    }
  }

  getInjectionValues() {
    if (this.supliedtoGridSchedules) {
      this.devicesService
        .getMetering(
          this.device.getDeviceId(),
          this.device.getModuleId(),
          this.activeView,
          this.datePipe.transform(this.currentSelectedDate, "yyyy-MM-dd"),
          this.datePipe.transform(this.getRespectiveEndDate(), "yyyy-MM-dd"),
          "ActiveEnergyInjected"
        )
        .subscribe(
          (injectionMetering) => {
            this.totalsOutput.emit(["injection", injectionMetering.totals]);
            this.totalsAux[0] = injectionMetering.totals;
            this.ChartLabels = this.getLabels(
              this.activeView,
              this.getRawLabels(injectionMetering)
            );
            this.values = this.getEnergyChartValues(
              this.mode,
              injectionMetering.energyChart,
              false
            );
            if (
              this.supliedtoGridSchedules &&
              this.totalsAux[0] &&
              this.totalsAux[0]["value"]["D"]
            ) {
              this.ChartData.push({
                data: Array.from(this.values[3].values()),
                label: this.generalService.translate.instant(
                  "Supplied to Grid"
                ),
                borderWidth: 0,
                stack: "1",
                backgroundColor: this.iterateColor("rgba(220, 187, 220, 1)"),
                hoverBackgroundColor: this.iterateColor("rgba(232,207,232,1)"),
              });
            }
            this.loading = false;
            this.refreshVisualDataRepresentation();
          },
          (err) => {
            this.loading = false;
            this.refreshVisualDataRepresentation();
          }
        );
    } else {
      this.loading = false;
    }
  }

  getPredictionLabels(chart: any): Array<string> {
    switch (chart.billingPeriod) {
      case HOUSE_BILLING_PERIOD.MONTHLY:
      case HOUSE_BILLING_PERIOD.BIMONTHLY:
        return this.getPredictionLabelsMonth(chart);
      case HOUSE_BILLING_PERIOD.ANUAL:
        return this.getPredictionLabelsAnual(chart);
    }
  }

  getPredictionLabelsMonth(chart: any): Array<string> {
    const labels: Array<string> = new Array<string>();

    chart.predictionChart.forEach((entry, index) => {
      labels.push(moment(entry.date).format("DD MMM"));
    });
    return labels;
  }

  getPredictionLabelsAnual(chart: any): Array<string> {
    const labels: Array<string> = new Array<string>();
    const lastIndex = chart.predictionChart
      ? chart.predictionChart.length - 1
      : 0;
    let previousYear = moment(chart.startBillingDate).get("year");

    chart.predictionChart.forEach((entry, index) => {
      const currentYear = moment(entry.date).get("year");
      if (index === 0) {
        labels.push(moment(chart.startBillingDate).format("DD MMM YYYY"));
      } else if (index === lastIndex) {
        labels.push(moment(chart.endBillingDate).format("DD MMM YYYY"));
      } else if (currentYear !== previousYear) {
        labels.push(moment(entry.date).format("MMM YYYY"));
        previousYear = currentYear;
      } else {
        labels.push(moment(entry.date).format("MMMM"));
      }
    });
    return labels;
  }

  getPredictionValues(chart: any): Array<Array<string>> {
    const realValues: Array<string> = new Array<string>();
    const predictionValues: Array<string> = new Array<string>();
    chart.predictionChart.forEach((entry) => {
      if (this.mode === "Eur") {
        predictionValues.push(Number(entry.cost.predictionCost).toFixed(3));
        realValues.push(Number(entry.cost.realCost).toFixed(3));
      } else {
        predictionValues.push(Number(entry.cost.predictionValue).toFixed(3));
        realValues.push(Number(entry.value.realValue).toFixed(3));
      }
    });
    return [realValues, predictionValues];
  }

  getRawLabels(chart: any): Array<string> {
    const labels: Array<string> = new Array<string>();
    if (chart.powerChart) {
      chart.powerChart.forEach((entry) => {
        labels.push(entry.date);
      });
    } else if (chart.energyChart) {
      chart.energyChart.forEach((entry) => {
        labels.push(entry.date);
      });
    }
    return labels;
  }

  getPowerValues(chart: any): Array<string> {
    let values: Array<string> = new Array<string>();
    const presentValues: Map<string, any> = new Map<string, any>();
    let auxDate: Date = new Date();
    chart.powerChart.forEach((entry) => {
      const dateAux: string = entry.date;
      const yearMonthDay = dateAux.split(" ")[0].split("-");
      const year = +yearMonthDay[0];
      const month = +yearMonthDay[1] - 1;
      const day = +yearMonthDay[2];
      if (yearMonthDay[2] == null) {
        auxDate = new Date(year, month);
      } else if (dateAux.split(" ")[1] != null) {
        const hourMinSec = dateAux.split(" ")[1].split(":");
        const hour = +hourMinSec[0];
        const min = +hourMinSec[1];
        const sec = +hourMinSec[2];
        auxDate = new Date(year, month, day, hour, min, sec);
      } else {
        auxDate = new Date(year, month, day);
      }
      /** Check Present values */
      if (this.activeView === "H") {
        presentValues.set(String(auxDate.getHours()), entry.value.D);
      } else if (this.activeView === "Q") {
        presentValues.set(
          String(auxDate.getHours() + ":" + auxDate.getMinutes()),
          entry.value.D
        );
      } else if (this.activeView === "D") {
        presentValues.set(String(auxDate.getDate()), entry.value.D);
      } else if (this.activeView === "M") {
        presentValues.set(
          String(auxDate.getMonth() + 1) + "#" + auxDate.getFullYear(),
          entry.value.D
        );
      }
    });

    /**Add corrected Values */
    values = this.addParsedValues(presentValues, auxDate);

    return values;
  }

  setGradient() {
    const id = setInterval(() => {
      if (this.canvas !== undefined) {
        const ctx: CanvasRenderingContext2D = this.canvas.nativeElement.getContext(
          "2d"
        );
        this.gradient = ctx.createLinearGradient(0, 0, 0, 400);
        this.gradient.addColorStop(0, "rgba(234,82,75,0.65)");
        this.gradient.addColorStop(0.65, "rgba(234,82,75,0.05)");
        this.powerChartColors = [
          {
            backgroundColor: this.gradient,
          },
        ];
        clearInterval(id);
      }
    }, 50);
  }

  addParsedValues(
    presentValues: Map<string, any>,
    auxDate: Date
  ): Array<string> {
    const values: Array<string> = new Array<string>();
    if (this.activeView === "H") {
      for (let d = 0; d < 24; d++) {
        if (presentValues.has(String(d))) {
          values.push(presentValues.get(String(d)));
        } else {
          values.push("0");
        }
      }
    } else if (this.activeView === "Q") {
      for (let h = 0; h < 24; h++) {
        let hour: string = String(h);
        if (hour.length === 1) {
          hour = "0" + hour;
        }
        for (let m = 0; m < 60; m = m + 15) {
          let minute: string = String(m);
          if (minute.length === 1) {
            minute = "0" + minute;
          }
          if (presentValues.has(String(h) + ":" + String(m))) {
            values.push(presentValues.get(String(h) + ":" + String(m)));
          } else {
            values.push("0");
          }
        }
      }
    } else if (this.activeView === "D") {
      if (!this.selectedMoments) {
        const lastDayOfMonth = Number(
          moment(auxDate).endOf("month").format("DD")
        );
        for (let d = 1; d <= lastDayOfMonth; d++) {
          if (presentValues.has(String(d))) {
            values.push(presentValues.get(String(d)));
          } else {
            values.push("0");
          }
        }
      } else {
        const lastDayOfMonth = Number(
          moment(this.selectedMoments[0]).endOf("month").format("DD")
        );
        const dateFrom = Number(this.ChartLabels[0]);
        const dateTo = Number(this.ChartLabels[this.ChartLabels.length - 1]);
        const interval = dateFrom - dateTo;
        for (let d = dateFrom; d <= lastDayOfMonth; d++) {
          if (presentValues.has(String(d))) {
            values.push(presentValues.get(String(d)));
          } else {
            values.push("0");
          }
        }
        for (let j = 1; j < dateTo + 1; j++) {
          if (presentValues.has(String(j))) {
            values.push(presentValues.get(String(j)));
          } else {
            values.push("0");
          }
        }
      }
    } else if (this.activeView === "M") {
      for (let i = 1; i <= 12; i++) {
        if (!this.selectedMoments) {
          if (presentValues.has(String(i) + "#" + this.getSelectedDate())) {
            values.push(
              presentValues.get(String(i) + "#" + this.getSelectedDate())
            );
          } else {
            values.push("0");
          }
        } else {
          const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];

          const dateF: Date = new Date(this.selectedMoments[0]);
          let dateT: Date = new Date();
          if (this.selectedMoments[1]) {
            dateT = new Date(this.selectedMoments[1]);
          } else {
            dateT = new Date(this.selectedMoments[0]);
          }

          const interval: number =
            Math.abs(dateT.getTime() - dateF.getTime()) / (1000 * 3600 * 24);

          const startMonth = dateF.getMonth();
          const endMonth = dateT.getMonth();

          // if (this.ChartLabels.indexOf(monthNames[i - 1]) !== -1) {
          //   if (presentValues.has(String(i))) {
          //     values.push(presentValues.get(String(i)));
          //   } else {
          //     values.push('0');
          //   }
          // }
          if (interval < 365) {
            const otherYear = startMonth >= endMonth ? true : false;
            if (otherYear) {
              for (let m = startMonth; m <= 11; m++) {
                if (
                  presentValues.has(String(m + 1) + "#" + dateF.getFullYear())
                ) {
                  values.push(
                    presentValues.get(String(m + 1) + "#" + dateF.getFullYear())
                  );
                } else {
                  values.push("0");
                }
              }
              for (let m = 0; m <= endMonth; m++) {
                if (
                  presentValues.has(String(m + 1) + "#" + dateT.getFullYear())
                ) {
                  values.push(
                    presentValues.get(String(m + 1) + "#" + dateT.getFullYear())
                  );
                } else {
                  values.push("0");
                }
              }
            } else {
              for (let m = startMonth; m <= endMonth || otherYear; m++) {
                if (
                  presentValues.has(String(m + 1)) +
                  "#" +
                  dateF.getFullYear()
                ) {
                  values.push(
                    presentValues.get(String(m + 1)) + "#" + dateF.getFullYear()
                  );
                } else {
                  values.push("0");
                }
              }
            }
          } else {
            for (let yN = 0; yN <= interval / 365; yN++) {
              for (
                let m = yN === 0 ? startMonth : 0;
                (m <= 11 && yN + 1 < interval / 365) ||
                (yN > 0 && m <= endMonth);
                m++
              ) {
                if (
                  presentValues.has(
                    String(m + 1) + "#" + (dateF.getFullYear() + Math.trunc(yN))
                  )
                ) {
                  values.push(
                    presentValues.get(
                      String(m + 1) +
                        "#" +
                        (dateF.getFullYear() + Math.trunc(yN))
                    )
                  );
                } else {
                  values.push("0");
                }
              }
            }
          }
        }
      }
    }
    return values;
  }

  getMaxcostPerkWh(costs) {
    let max = 0;
    if (costs["costPerkWhChart"]) {
      costs["costPerkWhChart"].forEach((entry) => {
        max = max < entry.cost ? entry.cost : max;
      });
    }
    return max;
  }
  getcostPerkWhChart(costs) {
    const result = new Array();
    const max = this.getMaxcostPerkWh(costs);
    if (costs["costPerkWhChart"]) {
      costs["costPerkWhChart"].forEach((entry) => {
        if (this.mode === "Eur") {
          result.push(entry.cost * (this.maxValue / (max * 2)));
        } else {
          result.push(entry.cost);
        }
      });
    }
    return result;
  }

  exportToExcel() {
    // Excel specific stuff
    let workbook = new ExcelJS.Workbook();
    let worksheet = workbook.addWorksheet();

    let excelData = JSON.parse(JSON.stringify(this.ChartData));
    excelData = this.deleteEnergyPriceFromObject(excelData);

    const columns = this.getTableColumns(excelData);
    const rows = this.getTableRows(excelData);

    worksheet.addTable({
      name: "EnergyTable",
      ref: "A1",
      headerRow: true,
      totalsRow: true,
      style: {
        theme: "TableStyleLight8",
      },
      columns: columns,
      rows: rows,
    });

    worksheet.columns.forEach((column) => {
      column.width = 22;
    });

    workbook.xlsx
      .writeBuffer()
      .then((data) => {
        const blob = new Blob([data], { type: EXCEL_TYPE });
        saveAs(blob, `Export de Dados.xlsx`);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  deleteEnergyPriceFromObject(excelData) {
    return excelData.filter(
      (element) =>
        element.label !== this.generalService.translate.instant("Energy Price")
    );
  }

  getTableColumns(excelData) {
    // Labels
    const mode = this.mode === "Eur" ? "€" : this.mode;
    let timeLabel;
    switch (this.activeView) {
      case "H":
      case "Q":
        timeLabel = this.generalService.translate.instant(`Hour`);
        break;
      case "D":
        timeLabel = this.generalService.translate.instant(`Day`);
        break;
      case "M":
        timeLabel = this.generalService.translate.instant(`Month`);
        break;
      default:
        timeLabel = this.generalService.translate.instant(`Hour`);
    }

    let columns = [
      {
        name: timeLabel,
        totalsRowLabel: this.generalService.translate.instant(`Total`),
        totalsRowFunction: undefined,
      },
    ];

    for (const key of excelData) {
      columns.push({
        name: `${key.label} (${mode})`,
        totalsRowLabel: undefined,
        totalsRowFunction: "sum",
      });
    }
    return columns;
  }

  getTableRows(excelData) {
    let rows = [];
    const numberOfIntervals = this.ChartLabels.length;

    // For each interval of time
    for (let i = 0; i < numberOfIntervals; i++) {
      rows[i] = [this.ChartLabels[i]];
      // Loop trough all "type of energy"
      for (const key of excelData) {
        rows[i].push(Number(key.data[i]));
      }
    }
    return rows;
  }

  convertToLocaleFormat(number): string {
    return this.decimalPipe.transform(
      number,
      "1.0-2",
      this.sessionStateService.getLang()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/new-graph/new-graph.component.ts